import {shape} from '../path/shapes.js';
import markItemPath from './markItemPath.js';

export default markItemPath('shape', shape);
